// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification {
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  box-sizing: border-box;
}
.notification__accent {
  width: 0.3rem;
  flex-shrink: 0;
}
.notification__body {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 1rem 1.25rem;
  width: 100%;
}
.notification__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  flex-shrink: 0;
}
.notification__content {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1;
}
.notification__title {
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.3;
}
.notification__description {
  font-size: 0.85rem;
  line-height: 1.4;
  opacity: 0.85;
}
.notification__close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0.5;
  transition: opacity 0.2s;
}
.notification__close:hover {
  opacity: 1;
}
.notification--success {
  background: linear-gradient(135deg, #f0faf0 0%, #f8fdf8 100%);
  border: 1px solid #c6e6c6;
}
.notification--success .notification__accent {
  background-color: #2e7d32;
}
.notification--success .notification__icon {
  background-color: #2e7d32;
  color: #fff;
}
.notification--success .notification__title {
  color: #1b5e20;
}
.notification--success .notification__description {
  color: #33691e;
}
.notification--success .notification__close {
  color: #1b5e20;
}
.notification--error {
  background: linear-gradient(135deg, #fef2f2 0%, #fefafa 100%);
  border: 1px solid #f5c6c6;
}
.notification--error .notification__accent {
  background-color: #c62828;
}
.notification--error .notification__icon {
  background-color: #c62828;
  color: #fff;
}
.notification--error .notification__title {
  color: #b71c1c;
}
.notification--error .notification__description {
  color: #c62828;
}
.notification--error .notification__close {
  color: #b71c1c;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ep-notification/ep-notification.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,cAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;AAFJ;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;AAME;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;AAJJ;AAOE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,wBAAA;AALJ;AAOI;EACE,UAAA;AALN;AAUE;EACE,6DAAA;EACA,yBAAA;AARJ;AAUI;EACE,yBAAA;AARN;AAWI;EACE,yBAAA;EACA,WAAA;AATN;AAYI;EACE,cAAA;AAVN;AAaI;EACE,cAAA;AAXN;AAcI;EACE,cAAA;AAZN;AAiBE;EACE,6DAAA;EACA,yBAAA;AAfJ;AAiBI;EACE,yBAAA;AAfN;AAkBI;EACE,yBAAA;EACA,WAAA;AAhBN;AAmBI;EACE,cAAA;AAjBN;AAoBI;EACE,cAAA;AAlBN;AAqBI;EACE,cAAA;AAnBN","sourcesContent":[".notification {\n  position: relative;\n  display: flex;\n  width: 100%;\n  margin-bottom: 1rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  box-sizing: border-box;\n\n  &__accent {\n    width: 0.3rem;\n    flex-shrink: 0;\n  }\n\n  &__body {\n    display: flex;\n    align-items: center;\n    gap: 0.875rem;\n    padding: 1rem 1.25rem;\n    width: 100%;\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2.25rem;\n    height: 2.25rem;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    flex: 1;\n  }\n\n  &__title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    line-height: 1.3;\n  }\n\n  &__description {\n    font-size: 0.85rem;\n    line-height: 1.4;\n    opacity: 0.85;\n  }\n\n  &__close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0.25rem;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    opacity: 0.5;\n    transition: opacity 0.2s;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  // Success variant\n  &--success {\n    background: linear-gradient(135deg, #f0faf0 0%, #f8fdf8 100%);\n    border: 1px solid #c6e6c6;\n\n    .notification__accent {\n      background-color: #2e7d32;\n    }\n\n    .notification__icon {\n      background-color: #2e7d32;\n      color: #fff;\n    }\n\n    .notification__title {\n      color: #1b5e20;\n    }\n\n    .notification__description {\n      color: #33691e;\n    }\n\n    .notification__close {\n      color: #1b5e20;\n    }\n  }\n\n  // Error variant\n  &--error {\n    background: linear-gradient(135deg, #fef2f2 0%, #fefafa 100%);\n    border: 1px solid #f5c6c6;\n\n    .notification__accent {\n      background-color: #c62828;\n    }\n\n    .notification__icon {\n      background-color: #c62828;\n      color: #fff;\n    }\n\n    .notification__title {\n      color: #b71c1c;\n    }\n\n    .notification__description {\n      color: #c62828;\n    }\n\n    .notification__close {\n      color: #b71c1c;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
